import { Component, Inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { defaultSeparator, multiValueValidate } from '@go-modules/validators/multi-value/multi-value.validator';
import { BehaviorSubject } from 'rxjs';
import { LibraryService, ShareLibraryItemResponse } from '@go-modules/services/library/library.service';
import { GO_MODAL_DATA } from '@go-modules/services/go-modal/go-modal.tokens';
import { GoDialogRef } from '@go-modules/services/go-dialog-ref/go-dialog-ref';

export interface ShareLibraryItemDialogData {
	collection_id: number;
	item_id: number;
}

@Component({
	selector: 'share-library-item-dialog',
	templateUrl: './share-library-item-dialog.component.html',
	styleUrls: ['./share-library-item-dialog.component.scss'],
	standalone: false
})
export class ShareLibraryItemDialogComponent {
	public form = new UntypedFormGroup({
		emails: new UntypedFormControl(null, [Validators.required, multiValueValidate(Validators.email)]),
		admin: new UntypedFormControl(false)
	});
	public isSaving$: BehaviorSubject<boolean> = new BehaviorSubject(false);

	constructor (
		private dialogRef: GoDialogRef,
		private libraryService: LibraryService,
		@Inject(GO_MODAL_DATA) public data: ShareLibraryItemDialogData
	) {}

	public submit () {
		if (!this.form.valid) {
			return;
		}

		this.isSaving$.next(true);

		const invites = this.getUniqueEmails();
		this.libraryService.shareCollectionItem({
			items: [{
				collection_id: this.data.collection_id,
				item_id: this.data.item_id
			}],
			users: invites
		}).subscribe({
			next: (result: ShareLibraryItemResponse) => this.dialogRef.close(result),
			error: () => {
				this.dialogRef.close({
					invalidUsers: invites
				});
			}
		});
	}

	public cancel () {
		this.dialogRef.close();
	}

	public getInvalidEmails (): string {
		return this.form.controls.emails.getError('multi')
			.map((error) => error.value)
			.join(', ');
	}

	private getUniqueEmails (): string[] {
		const emails = this.form.controls.emails.value.split(defaultSeparator);
		return emails.filter((email) => email.trim() !== '').filter((v, i, a) => a.indexOf(v) === i);
	}
}
